import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgPrevious = function SvgPrevious(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("g", {
    clipPath: "url(#previous_svg__clip0)"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M12.51 0c-6.609 0-12 5.39-12 12s5.391 12 12 12c6.61 0 12-5.39 12-12s-5.39-12-12-12zm6 12.984H8.949l2.297 2.297a1.02 1.02 0 010 1.406 1.033 1.033 0 01-.703.282c-.234 0-.516-.094-.703-.282l-3.985-3.984a1.02 1.02 0 010-1.406L9.84 7.312a1.02 1.02 0 011.406 0 1.02 1.02 0 010 1.407l-2.297 2.297h9.563a.99.99 0 01.984.984c0 .516-.469.984-.984.984z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "previous_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z",
    transform: "translate(.51)"
  }))));
};

export default SvgPrevious;